import React, { useEffect } from 'react';
import Navbar from '../components/Navbar.js';
import Footer from '../components/Footer.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Card1 from '../components/img/H.G. Mar Mathew.png';
import Card2 from '../components/img/H.E. Mar Joseph.png';
import MembersCard1 from '../components/img/Fr.Binu.png';
import MembersCard2 from '../components/img/Gheevarghese.png';
import MembersCard3 from '../components/img/Fr.Michael.png';
import MembersCard5 from '../components/img/Fr.Jinu.png';
import MembersCard6 from '../components/img/Adv.Joy.png';
import ExecutiveCard1 from '../components/img/Fr.Joice.png';
import ExecutiveCard2 from '../components/img/Fr. Stephen.png';
import ExecutiveCard3 from '../components/img/Fr.Roy.png';
import ExecutiveCard4 from '../components/img/Fr.jismon.png';
import ExecutiveCard5 from '../components/img/Fr.breson.png';
import ExecutiveCard6 from '../components/img/Dr.bobbie.png';
import ExecutiveCard7 from '../components/img/Dr.Sajan.png';
import ExecutiveCard8 from '../components/img/Dr. AJITH.png';
import PastoralCard3 from '../components/img/Fr. Graceson.png';
import NursingCard1 from '../components/img/Rev.Sr.Shiji.png';
import NursingCard2 from '../components/img/Sr. Chinnamma.png';
import HealthAdvisorCard from '../components/img/Mr.Tiny.png';
import FrSyju from "../components/img/fr-shyju.png";
import '../styles/pages.css';
import FrThomas from "../components/img/Fr-Thomas.png";
import FrAbraham from "../components/img/Fr-Abraham.png";
import MrThomas from "../components/img/Mr-Thomas.png";

function GoverningBody() {

    useEffect(() => {
        const pageSection = document.querySelector('.page-section');
        const deptMenu = document.getElementById('deptmenu');

        const handleScroll = () => {
            if (pageSection && deptMenu) {
                const pageSectionOffset = pageSection.offsetTop;
                const scrollPosition = window.scrollY;

                if (scrollPosition >= pageSectionOffset) {
                    deptMenu.classList.add('fixed-topnav');
                    deptMenu.style.top = '55px';  // Fix position at the top
                } else {
                    deptMenu.classList.remove('fixed-topnav');
                    deptMenu.style.top = `${pageSection.offsetHeight}px`;  // Set below page-section
                }
            }
        };

        // Ensure the navbar starts below the page section on page load
        if (pageSection && deptMenu) {
            deptMenu.style.top = `${pageSection.offsetHeight}px`;
        }

        // Attach scroll event listener
        window.addEventListener('scroll', handleScroll);

        // Call handleScroll immediately to ensure correct position on page load
        handleScroll();

        // Cleanup event listener when component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []); // Empty dependency array to run effect once when component mounts

    return (
        <div>
            {/* Navbar */}

                <Navbar />

            {/* Navbar Ending */}

            {/* Page Content starts here */}

            <section className="page-section">
                <div className="section-content">
                    <p className='page-heading'>Governing Body</p>
                    
                    <p className="page-subtitle">Meet Our Hospital Leadership Team</p>
                </div>
            </section>

            <section className="governing-navbar">
                <div className="fixed-topnav" id="deptmenu">
                    <div className="navbar " id="navbr"> 
                        <ul>
                            <li><a href="#trust">Caritas Hospital Trust </a></li>
                            <li><a href="#members">Members</a></li>
                            <li><a href="#board-of-executives">Board of Executives</a></li>
                            <li><a href="#pastoral-care"> Pastoral Care</a></li>
                            <li><a href="#department-of-nursing">Department of Nursing</a></li>
                            <li><a href="#hospital-advisor">Health Advisor</a></li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="hospital-trust" id="trust">

                <h3>Caritas Hospital Trust</h3>
                <br/>

                <div className="d-none d-md-block"> {/* Only works in Desktop */}
                    <p>
                        Discover the pillars of compassion and leadership within Caritas
                        <br/>
                        Charitable Trust, the heart and soul of Caritas Hospital.
                    </p>
                </div>

                <div className="d-md-none mb-2">{/* Only works in mobiles */}
                    <p>
                        Discover the pillars of compassion and leadership within Caritas Charitable Trust, the heart and soul of Caritas Hospital.
                    </p>
                </div>

                <div className='governing-trust-card-row'>

                    <div className="governing-trust-card">
                        <div className="governing-card-image">
                            <img src={Card1} alt="Service 1" />
                        </div>
                        <div className="governing-card-content">
                            <h5>H.G. Mar Mathew Moolakkatt</h5>
                            <p>
                                Metropolitan Archbishop of Kottayam &
                                <br/>
                                Patron, Caritas Hospital Trust
                            </p>
                        </div>
                    </div>
                    
                    <div className="governing-trust-card">
                        <div className="governing-card-image">
                            <img src={Card2} alt="Service 2" />
                        </div>
                        <div className="governing-card-content">
                            <h5>H.E. Mar Joseph Pandarasseril </h5>
                            <p>
                                Auxiliary Bishop of Kottayam &
                                <br/>
                                Chairman, Caritas Hospital Trust
                            </p>
                        </div>
                    </div>               
                </div>
            </section>

            <section className="governing-members" id="members">

                <h3>Members of the Trust</h3>
                <br/>

                <div className="d-none d-md-block"> {/* Only works in Desktop */}
                    <p>
                        Meet the dedicated members of Caritas Charitable Trust,
                        <br/>
                        The backbone of Caritas Hospital's mission and values.
                    </p>
                </div>

                <div className="d-md-none mb-2">{/* Only works in mobiles */}
                    <p>
                        Meet the dedicated members of Caritas Charitable Trust, The backbone of Caritas Hospital's mission and values.
                    </p>
                </div>
                
                <div className='governing-memebers-card'>
                    <div className='governing-card-row'>
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={MembersCard1} alt="Service 1" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Dr. Binu Kunnath</h5>
                                <p>Secretary</p>
                            </div>
                        </div>
                        
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={MembersCard2} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Gheevarghese Mar Aphrem</h5>
                                <p>Member</p>
                            </div>
                        </div>
                    </div>

                    <div className='governing-card-row'>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={FrThomas} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Thomas Animootil</h5>
                                <p>Member</p>
                            </div>
                        </div>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={FrAbraham} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Abraham Parambettu</h5>
                                <p>Member</p>
                            </div>
                        </div>
                    </div>

                    <div className='governing-card-row'>
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={MembersCard5} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Jinu Kavil</h5>
                                <p>Member</p>
                            </div>
                        </div>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={MembersCard6} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Adv. Joy Joseph Kodianthara</h5>
                                <p>Member</p>
                            </div>
                        </div>
                    </div>

                    <div className='governing-card-row'>
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={MrThomas} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Mr. Thomas Chazhikadan</h5>
                                <p>Member</p>
                            </div>
                        </div>
                    </div>
                </div>               
            </section>


            <section className="governing-executives" id="board-of-executives">

                <h3>Hospital Board of Executives</h3>
                <br/>

                <div className="d-none d-md-block"> {/* Only works in Desktop */}
                    <p>

                        Meet our highly regarded Executive Board members, the dynamic
                        <br/>
                        leaders steering Caritas Hospital's administration.
                    </p>
                </div>

                <div className="d-md-none mb-2">{/* Only works in mobiles */}
                    <p>
                        Meet our highly regarded Executive Board members, the dynamic leaders steering Caritas Hospital's administration.
                    </p>
                </div>
                
                <div className='governing-memebers-card'>
                    <div className='governing-card-row'>
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={MembersCard1} alt="Service 1" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Dr. Binu Kunnath</h5>
                                <p>Director, Caritas Hospital & Educational Institutions</p>
                            </div>
                        </div>
                        
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={MembersCard5} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Jinu Kavil</h5>
                                <p>Joint Director, Administration</p>
                            </div>
                        </div>
                    </div>

                    <div className='governing-card-row'>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={ExecutiveCard1} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Joice Nandikunnel</h5>
                                <p>Joint Director, Operations</p>
                            </div>
                        </div>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={ExecutiveCard2} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Stephen Thevarparambil</h5>
                                <p>Joint Director, Services</p>
                            </div>
                        </div>
                    </div>

                    <div className='governing-card-row'>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={ExecutiveCard3} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Roy Kanjirathummoottil</h5>
                                <p>Joint Director, Services</p>
                            </div>
                        </div>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={ExecutiveCard4} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Jismon Madathil</h5>
                                <p>Joint Director, Media & Relations</p>
                            </div>
                        </div>
                    </div>

                    <div className='governing-card-row'>
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={ExecutiveCard5} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Dr. Brasson Ozhungalil</h5>
                                <p>Director, Pastoral Care</p>
                            </div>
                        </div>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={ExecutiveCard6} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Dr. Bobbie N. Abraham </h5>
                                <p>Medical Director</p>
                            </div>
                        </div>
                    </div>

                    <div className='governing-card-row'>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={ExecutiveCard7} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Dr. Sajan Thomas</h5>
                                <p>Associate Medical Director</p>
                            </div>
                        </div>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={ExecutiveCard8} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Dr. Ajith Venugopalan</h5>
                                <p> Chief Operations Officer</p>
                            </div>
                        </div>
                    </div>
                </div>               
            </section>

            
            <section className="governing-pastoral-care" id="pastoral-care">

                <h3>Pastoral Care</h3>
                <br/>

                <div className="d-none d-md-block"> {/* Only works in Desktop */}
                    <p>
                        Discover the compassionate souls who guide the spiritual well-being of
                        <br/>
                        Caritas Hospital - our dedicated Pastoral Care members.
                    </p>
                </div>

                <div className="d-md-none mb-2">{/* Only works in mobiles */}
                    <p>
                    Discover the compassionate souls who guide the spiritual well-being of Caritas Hospital - our dedicated Pastoral Care members.
                    </p>
                </div>
                
                <div className='governing-memebers-card'>
                    <div className='governing-card-row'>
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={ExecutiveCard5} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Dr. Brasson Ozhungalil</h5>
                                <p>Director, Pastoral Care</p>
                            </div>
                        </div>

                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={FrSyju} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Shyju Kalluvettamkuzhi</h5>
                                <p>Assistant Director, Pastoral Care</p>
                            </div>
                        </div>
                    </div>

                    <div className='governing-card-row'>
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={PastoralCard3} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Fr. Graceson Jose Vengackal</h5>
                                <p>Assistant Director, Pastoral Care</p>
                            </div>
                        </div>
                    </div>
                </div>               
            </section>


            <section className="governing-nursing" id="department-of-nursing">

                <h3>Department of Nursing</h3>
                <br/>

                <div className="d-none d-md-block"> {/* Only works in Desktop */}
                    <p>
                        Get to know the leaders who make a profound impact on the well-being of
                        <br/>
                        our community through their exceptional nursing leadership.
                    </p>
                </div>

                <div className="d-md-none mb-2">{/* Only works in mobiles */}
                    <p>
                        Get to know the leaders who make a profound impact on the well-being of our community through their exceptional nursing leadership.
                    </p>
                </div>
                
                <div className='governing-memebers-card'>
                    <div className='governing-card-row'>
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={NursingCard1} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Rev. Sr. Shiji Jose</h5>
                                <p>Chief Nursing Officer</p>
                            </div>
                        </div>
                        
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={NursingCard2} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Sr. Chinnamma Thomas </h5>
                                <p>Assistant Nursing Officer</p>
                            </div>
                        </div>
                    </div>
                </div>               
            </section>


            <section className="governing-advisor" id="hospital-advisor">

                <h3>Hospital Advisor</h3>
                <br/>

                <div className="d-none d-md-block"> {/* Only works in Desktop */}
                    <p>
                        Meet the visionary behind the scenes, helping Caritas Hospital navigate the
                        <br/>
                        path towards innovation and superior patient care.
                    </p>
                </div>

                <div className="d-md-none mb-2">{/* Only works in mobiles */}
                    <p>
                        Meet the visionary behind the scenes, helping Caritas Hospital navigate the path towards innovation and superior patient care.
                    </p>
                </div>

                <div className='governing-memebers-card'>
                    <div className='governing-card-row'>
                        <div className="governing-card">
                            <div className="governing-card-image">
                                <img src={HealthAdvisorCard} alt="Service 2" />
                            </div>
                            <div className="governing-card-content">
                                <h5>Mr. Tiny Philip </h5>
                                <p>Hospital Advisor</p>
                            </div>
                        </div>
                    </div>
                </div>               
            </section>

            {/* Page content ends here */}

            {/* Footer */}

                <Footer />
            
            {/* Footer Ending */}
        </div>
    );
}

export default GoverningBody;